import { isValidE164 } from '@selenos/leads';
import { z } from 'zod';

export const ChatbotLeadSchema = z.object({
  phone: z
    .string()
    .min(1, 'Phone number is required')
    .refine(
      (val) => {
        const normalized = val.startsWith('+') ? val : `+${val}`;
        return isValidE164(normalized);
      },
      { message: 'Please enter a valid phone number with country code' },
    ),
  firstName: z
    .string()
    .min(1, 'First name is required')
    .max(100)
    .transform((v) => v.trim()),
  lastName: z
    .string()
    .min(1, 'Last name is required')
    .max(100)
    .transform((v) => v.trim()),
  email: z
    .string()
    .email('Please enter a valid email')
    .optional()
    .or(z.literal('')),
  consentGiven: z.literal(true, {
    message: 'You must provide consent to continue',
  }),
});

export type ChatbotLeadFormValues = z.infer<typeof ChatbotLeadSchema>;
